"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxWitnessSet = exports.isITxWitnessSet = void 0;
var cbor_1 = require("@harmoniclabs/cbor");
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var plutus_data_1 = require("@harmoniclabs/plutus-data");
var hashes_1 = require("../../hashes/index.js");
var script_1 = require("../../script/index.js");
var InvalidCborFormatError_1 = require("../../utils/InvalidCborFormatError.js");
var assert_1 = require("../../utils/assert.js");
var BootstrapWitness_1 = require("./BootstrapWitness.js");
var TxRedeemer_1 = require("./TxRedeemer.js");
var VKeyWitness_1 = require("./VKeyWitness/index.js");
;
function isUndefOrCheckedArr(stuff, arrayElemCheck) {
    return (stuff === undefined || (Array.isArray(stuff) &&
        stuff.every(arrayElemCheck)));
}
function isITxWitnessSet(set) {
    if (!(0, obj_utils_1.isObject)(set))
        return false;
    var _a = set, vkeyWitnesses = _a.vkeyWitnesses, nativeScripts = _a.nativeScripts, bootstrapWitnesses = _a.bootstrapWitnesses, plutusV1Scripts = _a.plutusV1Scripts, datums = _a.datums, redeemers = _a.redeemers, plutusV2Scripts = _a.plutusV2Scripts, plutusV3Scripts = _a.plutusV3Scripts;
    return (isUndefOrCheckedArr(vkeyWitnesses, function (vkeyWit) { return vkeyWit instanceof VKeyWitness_1.VKeyWitness; }) &&
        isUndefOrCheckedArr(nativeScripts, function (ns) { return ns instanceof script_1.Script && ns.type === script_1.ScriptType.NativeScript; }) &&
        isUndefOrCheckedArr(bootstrapWitnesses, function (bootWit) { return bootWit instanceof BootstrapWitness_1.BootstrapWitness; }) &&
        isUndefOrCheckedArr(plutusV1Scripts, function (pv1) { return pv1 instanceof script_1.Script && pv1.type === script_1.ScriptType.PlutusV1; }) &&
        isUndefOrCheckedArr(datums, plutus_data_1.isData) &&
        isUndefOrCheckedArr(redeemers, function (rdmr) { return rdmr instanceof TxRedeemer_1.TxRedeemer; }) &&
        isUndefOrCheckedArr(plutusV2Scripts, function (pv2) { return pv2 instanceof script_1.Script && pv2.type === script_1.ScriptType.PlutusV2; }) &&
        isUndefOrCheckedArr(plutusV3Scripts, function (pv3) { return pv3 instanceof script_1.Script && pv3.type === script_1.ScriptType.PlutusV3; }));
}
exports.isITxWitnessSet = isITxWitnessSet;
var TxWitnessSet = /** @class */ (function () {
    function TxWitnessSet(witnesses, allRequiredSigners) {
        if (allRequiredSigners === void 0) { allRequiredSigners = undefined; }
        var _this = this;
        var _a;
        (0, assert_1.assert)(isITxWitnessSet(witnesses), "invalid witnesses passed");
        var defGetter = function (name, get) {
            (0, obj_utils_1.definePropertyIfNotPresent)(_this, name, {
                get: get,
                set: function () { },
                enumerable: true,
                configurable: false
            });
        };
        function cloneArr(arr) {
            var _a;
            return (_a = arr === null || arr === void 0 ? void 0 : arr.map(function (element) { return element.clone(); })) !== null && _a !== void 0 ? _a : [];
        }
        function defGetterArr(name, elems) {
            var _elems = elems !== null && elems !== void 0 ? elems : [];
            defGetter(name, function () { return _elems.length === 0 ? undefined : cloneArr(_elems); });
        }
        var vkeyWitnesses = witnesses.vkeyWitnesses, bootstrapWitnesses = witnesses.bootstrapWitnesses, datums = witnesses.datums, nativeScripts = witnesses.nativeScripts, plutusV1Scripts = witnesses.plutusV1Scripts, plutusV2Scripts = witnesses.plutusV2Scripts, redeemers = witnesses.redeemers, plutusV3Scripts = witnesses.plutusV3Scripts;
        var _vkeyWits = (_a = vkeyWitnesses === null || vkeyWitnesses === void 0 ? void 0 : vkeyWitnesses.map(function (wit) { return wit.clone(); })) !== null && _a !== void 0 ? _a : [];
        defGetterArr("vkeyWitnesses", _vkeyWits);
        defGetterArr("bootstrapWitnesses", bootstrapWitnesses);
        defGetterArr("datums", datums);
        defGetterArr("nativeScripts", nativeScripts);
        defGetterArr("plutusV1Scripts", plutusV1Scripts);
        defGetterArr("plutusV2Scripts", plutusV2Scripts);
        defGetterArr("redeemers", redeemers);
        defGetterArr("plutusV3Scripts", plutusV3Scripts);
        var _reqSigs = Array.isArray(allRequiredSigners) && allRequiredSigners.every(function (reqSig) { return reqSig instanceof hashes_1.Hash28; }) ?
            allRequiredSigners.map(function (sig) { return sig.toString(); }) :
            undefined;
        var noRequiredSigs = _reqSigs === undefined;
        Object.defineProperty(this, "isComplete", {
            get: function () { return noRequiredSigs ||
                _reqSigs.every(function (sig) {
                    return _vkeyWits.some(function (wit) { return wit.vkey.hash.toString() === sig; });
                }); },
            set: function () { },
            configurable: false,
            enumerable: true
        });
        (0, obj_utils_1.defineReadOnlyProperty)(this, "addVKeyWitness", function (vkeyWit) {
            // if(
            //     noRequiredSigs ||
            //     _reqSigs.includes( vkeyWit.vkey.hash.toString() )
            // )
            // {
            //     _vkeyWits.push( vkeyWit.clone() );
            // }
            _vkeyWits.push(vkeyWit.clone());
        });
    }
    TxWitnessSet.prototype.toJson = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return {
            vkeyWitnesses: (_a = this.vkeyWitnesses) === null || _a === void 0 ? void 0 : _a.map(function (vkWit) { return vkWit.toJson(); }),
            nativeScripts: (_b = this.nativeScripts) === null || _b === void 0 ? void 0 : _b.map(function (ns) { return ns.toJson(); }),
            bootstrapWitnesses: (_c = this.bootstrapWitnesses) === null || _c === void 0 ? void 0 : _c.map(function (bWit) { return bWit.toJson(); }),
            plutusV1Scripts: (_d = this.plutusV1Scripts) === null || _d === void 0 ? void 0 : _d.map(function (s) { return s.toJson(); }),
            datums: (_e = this.datums) === null || _e === void 0 ? void 0 : _e.map(function (dat) { return dat.toJson(); }),
            redeemers: (_f = this.redeemers) === null || _f === void 0 ? void 0 : _f.map(function (rdmr) { return rdmr.toJson(); }),
            plutusV2Scripts: (_g = this.plutusV2Scripts) === null || _g === void 0 ? void 0 : _g.map(function (s) { return s.toJson(); }),
            plutusV3Scripts: (_h = this.plutusV3Scripts) === null || _h === void 0 ? void 0 : _h.map(function (s) { return s.toJson(); }),
        };
    };
    TxWitnessSet.prototype.toCbor = function () {
        return cbor_1.Cbor.encode(this.toCborObj());
    };
    TxWitnessSet.prototype.toCborObj = function () {
        return new cbor_1.CborMap([
            this.vkeyWitnesses === undefined ? undefined :
                {
                    k: new cbor_1.CborUInt(0),
                    v: new cbor_1.CborArray(this.vkeyWitnesses.map(function (witness) { return witness.toCborObj(); }))
                },
            this.nativeScripts === undefined ? undefined :
                {
                    k: new cbor_1.CborUInt(1),
                    v: new cbor_1.CborArray(this.nativeScripts.map(function (nativeScript) { return nativeScript instanceof script_1.Script ?
                        cbor_1.Cbor.parse(nativeScript.cbor) :
                        (0, script_1.nativeScriptToCborObj)(nativeScript); }))
                },
            this.bootstrapWitnesses === undefined ? undefined :
                {
                    k: new cbor_1.CborUInt(2),
                    v: new cbor_1.CborArray(this.bootstrapWitnesses.map(function (w) { return w.toCborObj(); }))
                },
            this.plutusV1Scripts === undefined ? undefined :
                {
                    k: new cbor_1.CborUInt(3),
                    v: new cbor_1.CborArray(this.plutusV1Scripts
                        .map(function (script) { return cbor_1.Cbor.parse(script.cbor); }))
                },
            this.datums === undefined ? undefined :
                {
                    k: new cbor_1.CborUInt(4),
                    v: new cbor_1.CborArray(this.datums.map(plutus_data_1.dataToCborObj))
                },
            this.redeemers === undefined ? undefined :
                {
                    k: new cbor_1.CborUInt(5),
                    v: new cbor_1.CborArray(this.redeemers.map(function (r) { return r.toCborObj(); }))
                },
            this.plutusV2Scripts === undefined ? undefined :
                {
                    k: new cbor_1.CborUInt(6),
                    v: new cbor_1.CborArray(this.plutusV2Scripts
                        .map(function (script) { return cbor_1.Cbor.parse(script.cbor); }))
                },
            this.plutusV3Scripts === undefined ? undefined :
                {
                    k: new cbor_1.CborUInt(7),
                    v: new cbor_1.CborArray(this.plutusV3Scripts
                        .map(function (script) { return cbor_1.Cbor.parse(script.cbor); }))
                },
        ]
            .filter(function (elem) { return elem !== undefined; }));
    };
    TxWitnessSet.fromCbor = function (cStr) {
        return TxWitnessSet.fromCborObj(cbor_1.Cbor.parse((0, cbor_1.forceCborString)(cStr)));
    };
    TxWitnessSet.fromCborObj = function (cObj) {
        var _a;
        if (!(cObj instanceof cbor_1.CborMap))
            throw new InvalidCborFormatError_1.InvalidCborFormatError("TxWitnessSet");
        var fields = new Array(8).fill(undefined);
        var _loop_1 = function (i) {
            var v = ((_a = cObj.map.find(function (_a) {
                var k = _a.k;
                return k instanceof cbor_1.CborUInt && Number(k.num) === i;
            })) !== null && _a !== void 0 ? _a : { v: undefined }).v;
            if (v === undefined || !(0, cbor_1.isCborObj)(v))
                return "continue";
            fields[i] = v;
        };
        for (var i = 0; i < 7; i++) {
            _loop_1(i);
        }
        var _b = __read(fields, 8), _vkey = _b[0], _native = _b[1], _bootstrap = _b[2], _plutusV1 = _b[3], _dats = _b[4], _reds = _b[5], _plutusV2 = _b[6], _plutusV3 = _b[7];
        // redeemer might be either array or map in conway
        if (!((_vkey === undefined || _vkey instanceof cbor_1.CborArray) &&
            (_native === undefined || _native instanceof cbor_1.CborArray) &&
            (_bootstrap === undefined || _bootstrap instanceof cbor_1.CborArray) &&
            (_plutusV1 === undefined || _plutusV1 instanceof cbor_1.CborArray) &&
            (_dats === undefined || _dats instanceof cbor_1.CborArray) &&
            (_plutusV2 === undefined || _plutusV2 instanceof cbor_1.CborArray) &&
            (_plutusV3 === undefined || _plutusV3 instanceof cbor_1.CborArray)))
            throw new InvalidCborFormatError_1.InvalidCborFormatError("TxWitnessSet");
        return new TxWitnessSet({
            vkeyWitnesses: _vkey === undefined ? undefined : _vkey.array.map(VKeyWitness_1.VKeyWitness.fromCborObj),
            nativeScripts: _native === undefined ? undefined :
                _native.array.map(function (nativeCborObj) {
                    return new script_1.Script(script_1.ScriptType.NativeScript, cbor_1.Cbor.encode(nativeCborObj).toBuffer());
                }),
            bootstrapWitnesses: _bootstrap === undefined ? undefined :
                _bootstrap.array.map(BootstrapWitness_1.BootstrapWitness.fromCborObj),
            plutusV1Scripts: _plutusV1 === undefined ? undefined :
                _plutusV1.array.map(function (cbor) {
                    return new script_1.Script(script_1.ScriptType.PlutusV1, cbor_1.Cbor.encode(cbor).toBuffer());
                }),
            datums: _dats === undefined ? undefined :
                _dats.array.map(plutus_data_1.dataFromCborObj),
            redeemers: _reds === undefined ? undefined : witnessRedeemersFromCborObj(_reds),
            plutusV2Scripts: _plutusV2 === undefined ? undefined :
                _plutusV2.array.map(function (cbor) {
                    return new script_1.Script(script_1.ScriptType.PlutusV2, cbor_1.Cbor.encode(cbor).toBuffer());
                }),
            plutusV3Scripts: _plutusV3 === undefined ? undefined :
                _plutusV3.array.map(function (cbor) {
                    return new script_1.Script(script_1.ScriptType.PlutusV3, cbor_1.Cbor.encode(cbor).toBuffer());
                }),
        });
    };
    return TxWitnessSet;
}());
exports.TxWitnessSet = TxWitnessSet;
function witnessRedeemersFromCborObj(cbor) {
    if (cbor instanceof cbor_1.CborArray) {
        return cbor.array.map(TxRedeemer_1.TxRedeemer.fromCborObj);
    }
    else if (cbor instanceof cbor_1.CborMap) {
        return cbor.map.map(TxRedeemer_1.TxRedeemer.fromCborMapEntry);
    }
    else
        throw new Error("invalid format for witness set redeemers field");
}
